import React, { useEffect, useState } from "react";
import { GetFamilyById } from "../../DAL/fetch";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { uploadFile } from "../../DAL/create";
import { fileUrl } from "../../Config/Config";
import { updateFamilyData } from "../../DAL/update";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { enqueueSnackbar } from "notistack";

export const UpdateFamily = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState(null);
  const [type, setType] = useState(false);
  const [inputs, setInputs] = useState({
    email: "",
    phoneNumber: "",
    status: "",
    description: "",
    pictureUrl: "",
  });

  const FetchFamilyDetailById = async () => {
    const resp = await GetFamilyById(params?.id);
    if (resp.status == 200) {
      setInputs(resp.data);
      setPreviewImage(resp?.data?.pictureUrl);
    }
  };

  const handleImageUpload = async (e) => {
    const formData = new FormData();
    formData.append("image", e.target.files[0]);
    const resp = await uploadFile(formData);
    setPreviewImage(URL.createObjectURL(e.target.files[0]));
    setType(true);
    setInputs((prev) => ({ ...prev, pictureUrl: resp?.data?.url }));
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      name: inputs?.name,
      pictureUrl: inputs?.pictureUrl,
      description: inputs?.description,
      status: inputs?.status,
      email: inputs?.email,
      phoneNumber: inputs?.phoneNumber,
    };
    const resp = await updateFamilyData(params?.id, data);
    if (resp.status == 200) {
      enqueueSnackbar("Family update successfully", { variant: "success" });
      navigate(`/family-list/${inputs?.status}`);
    } else {
      enqueueSnackbar(
        resp?.message[0]?.constraints || "Error while update family",
        { variant: "error" }
      );
    }
  };
  useEffect(() => {
    FetchFamilyDetailById();
  }, []);
  return (
    <>
      <div className="mainDiv">
        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <Typography variant="h6">Edit Family Detail</Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "5px" }}>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextField
              label="Name"
              fullWidth
              size="small"
              name="name"
              value={inputs?.name || ""}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextField
              label="Email"
              fullWidth
              size="small"
              name="email"
              value={inputs?.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextField
              label="Phone No"
              type="number"
              fullWidth
              size="small"
              name="phoneNumber"
              value={inputs?.phoneNumber}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inputs?.status}
                label="Status"
                name="status"
                onChange={handleChange}
              >
                <MenuItem value={"Pending"}>Pending</MenuItem>
                <MenuItem value={"Active"}>Active</MenuItem>
                <MenuItem value={"Blocked"}>Blocked</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              label="Description"
              fullWidth
              name="description"
              multiline
              rows={5}
              value={inputs?.description}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12} sx={{ marginTop: "10px" }}>
            <Grid container spacing={2}>
              <Grid item lg={4} md={4} sm={4} xs={4}>
                <Typography>Upload Image *</Typography>
                <FormHelperText>Image Size(200X100)</FormHelperText>
              </Grid>
              <Grid
                item
                lg={2}
                md={2}
                sm={2}
                xs={2}
                sx={{ textAlign: "center" }}
              >
                <img
                  src={type == true ? previewImage : fileUrl + previewImage}
                  alt=""
                  style={{ width: "80%", height: "70px" }}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "end" }}>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="upload-button"
                  type="file"
                  onChange={handleImageUpload}
                />
                <label htmlFor="upload-button">
                  <Button
                    variant="contained"
                    component="span"
                    sx={{
                      background: "linear-gradient(to right, #5301d7, #008eca)",
                      color: "white",
                    }}
                  >
                    Upload
                  </Button>
                </label>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={6} sm={12} xs={12} sx={{ textAlign: "end" }}>
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{
                background: "linear-gradient(to right, #5301d7, #008eca)",
                color: "white",
              }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
